import { render, staticRenderFns } from "./ProductItemDisplay.vue?vue&type=template&id=78699b19&scoped=true&"
import script from "./ProductItemDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductItemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemDisplay.vue?vue&type=style&index=0&id=78699b19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78699b19",
  null
  
)

export default component.exports